module.exports = __webpack_public_path__ + "static/img/zzns2.e159e98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/desktop/zzns2.jpg
// module id = Hqww
// module chunks = 15